import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";
import { Checkbox } from "primereact/checkbox";

import { AuthContext } from "../../../Context/AuthContext/AuthContext";
import { useForm } from "../../../Hooks/useForm";
import Loader from "../../../Components/Loader/Loader";
import { getMenus } from "../../../API/IT/Menu/MenuRequests";
import AutoCompleteDropdown from "../../../Components/Form/AutoCompleteDropdown";
import { toastShow } from "../../../Services/ToastService"; 

import { EditarMetrica, GuardarMetrica } from "../../../API/IT/Metricas/MetricasRequest"; 


const MetricasCRUD = ({ showDialog, selected, setShowDialog, getInfo, modo }) => {
  const toastDialog = useRef(null);
  const toast = useRef(null);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [menus, setMenus] = useState([]);

  const initialValues = {
    IdMetrica: -1,
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);
 
    const menusTempo = await getMenus()
    setMenus(menusTempo)

    const menuInicial = modo === "Crear" ? null : menusTempo.find((e) => e.IdMenu === selected?.IdMenu);


    setValues({
      ...selected,
      Menu: menuInicial?.Titulo,
      IdMenu: menuInicial?.IdMenu,
    });

    setLoading(false);
  };

  const onHide = () => {
    setShowDialog(false);
    resetForm();
  };

  const verificarInfo = () => {
    let error = {};

    if (!values.Nombre) {
      error.Nombre = true;
      error.error = true;
    }
    if(values?.IdMetrica > 0){
      if (!values.Menu) {
        error.IdMenu = true;
        error.error = true;
      }
    }else{
      if (!values.Menu?.IdMenu) {
        error.IdMenu = true;
        error.error = true;
      }
    }

    setError(error);
    return error;
  };

  const agregarMetrica = async () => {
    const e = verificarInfo();
    if(!e?.error){

      const Datos = {
        IdMetrica: values?.IdMetrica ? values?.IdMetrica : -100,
        Nombre: values?.Nombre,
        Descripcion: values?.Descripcion,
        IdMenu: values?.Menu?.IdMenu || values?.IdMenu,
        Pm2: values?.Pm2,
        IdUserCreate: userAuth?.IdUser,
      }
      setLoading(true)


      if(Datos?.IdMetrica > 0){
          const respuesta = await EditarMetrica(Datos)
          if (respuesta[0].ESTADO !== -1) {
              toastShow(toast, "success", "Editada", respuesta[0].MENSAJE);
              setTimeout(() => {
                  onHide();
                  setLoading(false);
                  getInfo();
              }, 1500);
          } else {
              toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
              setLoading(false);
          }
      }else{
        const respuesta = await GuardarMetrica(Datos)
        if (respuesta[0].ESTADO !== -1) {
          toastShow(toast, "success", "Guardado", respuesta[0].MENSAJE);
          setTimeout(() => {
            onHide();
            setLoading(false);
            getInfo();
          }, 1500);
        } else {
          toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
          setLoading(false);
        }
      }
    }
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={"Guardar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={agregarMetrica}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);

  const dialogTitle = modo === "Crear" ? "Agregar Métrica" : "Editar Métrica";

  return (
    <div>
      <Dialog
        visible={showDialog}
        modal
        className="modal__contenedor modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
      <Toast ref={toast} style={{ zIndex: 50000 }} />
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ width: "100", margin: "auto" }}>
            <div className="d-flex align-items-center">
              <h2 className="me-3">{dialogTitle}</h2>
            </div>
            <Toast ref={toastDialog} style={{ zIndex: 50000 }} />

            <div className="modal__input-contenedor">
              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Nombre"
                    value={values.Nombre}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.Nombre ? "p-invalid" : ""}
                  />
                  <label htmlFor="Nombre">Nombre de Métrica</label>
                </span>
              </div>

              <div className="field col-6 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Descripcion"
                    value={values.Descripcion}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.Descripcion ? "p-invalid" : ""}
                  />
                  <label htmlFor="Descripcion">Descripción</label>
                </span>
              </div>

 
            </div>


            <div className="modal__input-contenedor">
              <div className="field col-6 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Menu"}
                    value={values.Menu}
                    items={menus}
                    field={"Titulo"}
                    label={"Menu"}
                    handleInputChange={handleInputChange}
                    className={error.IdMenu ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-6 mt-3">
              <span className="p-float-label">
                <Checkbox
                  checked={values.Pm2}
                  onChange={(e) =>
                    setValues({
                      ...values,
                      Pm2: e.target.checked,
                    })
                  }
                />
                <label htmlFor="Pm2">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Pm2
                </label>
              </span>
            </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default MetricasCRUD;
